module.exports = __webpack_public_path__ + "static/media/5DPO19.ef42ba4b.jpg";